export default __webpack_public_path__ + "static/media/EmptyValueLogo.3c5d7f5e.png";